<template>
  <div v-if="selectedCategory" class="category-selector" @click="onClickLabel">
    <div class="select-container" :class="{active: isOpen}">
      <div class="label">
        {{ $filters.translate(selectedCategory.name) }}
        <div class="arrow arrow-down" :class="{'arrow-up': isOpen}" />
      </div>
      <div class="categories">
        <div
          v-for="category in eventCategories"
          class="label"
          :class="{active: category === selected.category}"
          @click="onClickCategory(category)"
        >
          <span class="dot" :style="{backgroundColor: category.bgColor}" />
          {{ $filters.translate(category.name) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: [
    'selected',
    'eventCategories'
  ],
  data () {
    return {
      isOpen: false,
      selectedCategory: null
    }
  },
  mounted () {
    if (this.selected.category) {
      this.selectedCategory = this.selected.category
    } else {
      this.selectedCategory = _.first(this.eventCategories)
    }
  },
  methods: {
    onClickLabel () {
      this.isOpen = !this.isOpen
    },
    onClickCategory (category) {
      this.isOpen = false
      _.set(this.selected, 'category', category)
      this.$emit('update:selected', _.clone(this.selected))
      this.$emit('change', _.clone(this.selected))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/_variables.scss';

.category-selector {
  padding: 16px 25px;
  display: none;
  // border: 1px red solid;
  .select-container {
    overflow: hidden;
    background-color: white;
    z-index: 3;
    margin-top: -20px;
    width: calc(100% - 50px);
    position: absolute;
    border: 1px #404851 solid;
    font-size: 16px;
    padding: 10px 20px;
    padding-bottom: 0px;
    border-radius: 24px;
    cursor: pointer;
    >.label {
      padding-bottom: 10px;;
      border-bottom: 0px #404851 solid;
      &:hover {
        color: #888888;
      }
    }

  }

  .arrow {
    border: solid #404851;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 5px;
  }
  .arrow-down {
    position: absolute;
    top: 0px;
    right: 0px;
    margin-top: 10px;
    margin-right: 20px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    // transition: transform 0.4s;
  }
  .arrow-up {
    position: absolute;
    top: 0px;
    right: 0px;
    margin-top: 14px;
    margin-right: 20px;
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135eg);
  }
  .categories {
    // border-top: 1px #404851 solid;
    height: 0px;
    opacity: 0;
    transition: height, margin-top, padding-top, opacity 0.4s;
    .label {
      padding-top: 10px;
      margin-bottom: 10px;
      padding-left: 0px;
      display: flex;
      align-items: center;
      width: 100%;
      &:hover {
        color: #888888;
      }
      &.active {
        color: $color-hkbu-blue-background;
      }
    }
    .dot {
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin-right: 20px;
    }

  }
  .select-container.active {

    >.label {
      border-bottom: 1px #404851 solid;
    }

    .categories {
      opacity: 1;
      margin-top: 10px;
      padding-top: 10px;
      height: auto;
    }
  }
}

@media screen and (max-width: 768px)
{
  .category-selector {
    display: block;
  }
}
</style>
